<footer class="app-footer__wrapper" data-e2e="footer-fragment">
  <!-- Footer links -->
  <div class="app-footer__section app-footer-links">
    <app-link
      *ngFor="let link of legalLinks"
      [e2e]="'footer-fragment' + link.e2e"
      [link]="link"
    ></app-link>
  </div>
</footer>
